module.exports = __webpack_public_path__ + "static/product-2-mobile-59f1ddd08062b5387bc6691a4ef2214a.png";